import { IsNotEmpty, IsUUID } from 'class-validator';

export class MergeSuppliersDto {
  @IsUUID()
  @IsNotEmpty()
  survivorId!: string;

  @IsUUID()
  @IsNotEmpty()
  duplicateId!: string;
}
